import styles from "./Disclaimer.module.scss";
import { PinOutlined as Pin24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/PinOutlined";
import { BillingOutlined as Billing24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/BillingOutlined";
import { AgeLimit18Outlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/AgeLimit18Outlined";
import { TickCircleOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/TickCircleOutlined";
import { BasketOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/BasketOutlined";
import { OpenInNewOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/OpenInNewOutlined";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";

interface DisclaimerProps {
  disclaimerClickHandler?: () => void;
}
export const Disclaimer = ({ disclaimerClickHandler }: DisclaimerProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.disclaimer} data-testid="disclaimer:introduction">
        John Lewis plc is a credit broker and not a lender. Credit provided by
        Creation.
      </div>
      <div className={styles.section} data-testid="disclaimer:who-can-apply">
        <div className={styles.header}>Who can apply</div>
        <div className={styles.point}>
          <AgeLimit18Outlined size="medium" />
          18 years or over
        </div>
        <div className={styles.point}>
          <Pin24PxOutlinedIcon size="medium" />
          UK resident for a minimum of 3 years
        </div>
        <div className={styles.point}>
          <Billing24PxOutlinedIcon size="medium" />
          Annual income of £10,000 or more*
        </div>
      </div>
      <div className={styles.section} data-testid="disclaimer:how-to-apply">
        <div className={styles.header}>How to apply</div>
        <div className={styles.point}>
          <BasketOutlined size="medium" />
          Choose your finance option at checkout
        </div>
        <div className={styles.point}>
          <TickCircleOutlined size="medium" />
          Complete eligibility process with our provider, Creation
        </div>
      </div>
      <div className={styles.section} data-testid="disclaimer:more-information">
        <div className={styles.findOutMoreGroup}>
          <UnderlinedButton
            tag="a"
            href="https://www.johnlewis.com/our-services/paymentplans"
            target="_blank"
            role="button"
            className={styles.button}
            data-testid="disclaimer:more-information-button"
            onClick={disclaimerClickHandler}
          >
            Find out more about credit
          </UnderlinedButton>
          <OpenInNewOutlined size="medium" />
        </div>
        <p className={styles.annotation}>
          * We&apos;ll consider joint income if you&apos;re either married,
          living with a partner, in a civil partnership, in receipt of
          Disability Allowance, Employment and Support Allowance, or Personal
          Independence Payment.
        </p>
        <p className={styles.annotation}>
          Please note that the amount displayed is for one item only. Additional
          services are not included.
        </p>
        <p className={styles.annotation}>
          Credit subject to status, UK residents only, 18 and over.
        </p>
      </div>
    </div>
  );
};
